import React, { useState } from "react";
import {
  Box,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import { ChevronLeft } from "lucide-react";
import useFetch from "../../hooks/useFetch";
import { orderhistory_api } from "../../api/urls";
import { api } from "../../api/api";
import { toast } from "react-toastify";

const StepCancelReason = ({
  cancelReason,
  setCancelReason,
  additionalComments,
  setAdditionalComments,
  onNext,
  setIsCancel,
  orderID,
  orderData,
  setStep,
}) => {
  const [isAccept, setIsAccept] = useState(false);
  const [loading, setLoading] = useState(false);
  // MAke continue click only isaccpet
  const { data } = useFetch(orderhistory_api + `${orderID}/cancelproduct/`);

  const payload = {
    reason_choices: cancelReason,
    reason_comment: additionalComments,
    cart_id: orderID,
  };
  const handleContinue = async () => {
    if (orderData?.bank_structure.length === 0) {
      try {
        setLoading(true);
        await api.patch(
          orderhistory_api + `${orderID}/cancelproduct/`,
          payload
        );
        setStep(3);
      } catch (error) {
        toast.error(error.response?.data?.data || "Something went wrong");
      } finally {
        setLoading(false);
      }
    } else {
      onNext();
    }
  };
  return (
    <Box
      sx={{
        mx: "auto",
        p: 4,
      }}
    >
      <Box display="flex" alignItems="center" mb={3} style={{ color: "gray" }}>
        {/* <Typography fontSize="14px" fontWeight={500} sx={{ ml: 1 }}> */}
        <IconButton onClick={() => setIsCancel(false)} size="small">
          <ChevronLeft size={20} />
        </IconButton>{" "}
        Back
      </Box>

      {/* Heading */}
      <Typography
        variant="h5"
        sx={{ fontSize: "28px" }}
        fontWeight={500}
        mb={1}
      >
        Cancel Order 
      </Typography>
      <Typography
        variant="h5"
        sx={{ fontSize: "20px" }}
        fontWeight={500}
        mb={1}
      >
        Reason for cancellation
      </Typography>
      <Typography sx={{ fontSize: "13px" }} color="text.secondary" mb={2}>
        Please tell us correct reason for cancellation. This information is only
        used to improve our service
      </Typography>

      {/* Radio group */}
      <Typography fontWeight={500} fontSize="20px" mb={1}>
        Select Reason*
      </Typography>

      <RadioGroup
        value={cancelReason}
        onChange={(e) => {
          setCancelReason(e.target.value);
          setIsAccept(e.target.name);
        }}
        sx={{ mb: 3 }}
      >
        {data?.questions.map(({ question, id, accept }, i) => (
          <React.Fragment key={i}>
            <FormControlLabel
              value={question}
              control={<Radio />}
              label={question}
              name={accept}
            />
            {!accept && cancelReason === question && (
              <Typography variant="body2" style={{ color: "red" }}>
                This reason is not acceptable
              </Typography>
            )}
          </React.Fragment>
        ))}
      </RadioGroup>

      <Typography fontWeight={600} fontSize="14px" mb={1}>
        Additional Comments
      </Typography>
      <TextField
        placeholder="Description"
        value={additionalComments}
        onChange={(e) => {
          setAdditionalComments(e.target.value);
        }}
        fullWidth
        multiline
        minRows={3}
        variant="outlined"
        sx={{ mb: 4 }}
      />

      <Box display="flex" justifyContent="flex-end">
        <Button
          variant="contained"
          onClick={handleContinue}
          disabled={(!cancelReason && !isAccept) || loading}
          sx={{
            textTransform: "none",
            backgroundColor: "#000",
            color: "#fff",
            px: 4,
            "&:hover": { backgroundColor: "#222" },
          }}
        >
          Continue
        </Button>
      </Box>
    </Box>
  );
};

export default StepCancelReason;
